import React from "react";

import { MoneyIcon, TipsAndUpdatesIcon } from "@/icons";
import {
  WindowSharp,
  ThreePOutlined,
  Diversity1Outlined,
  CalendarMonthOutlined,
  ContactMailOutlined,
  MultipleStopOutlined,
  NextPlanOutlined,
  SmsOutlined,
  DescriptionOutlined,
  BuildOutlined,
  EmailOutlined,
  AirlineSeatReclineNormal,
  WorkspacePremiumOutlined,
  HolidayVillage,
  Groups,
  Badge,
  Psychology,
  Mail as MailIcon,
} from "@mui/icons-material";
import { path, text } from "d3";

const menuItems = [
  {
    text: "Dashboard",
    path: "/dashboard",
    submenu: [],
    icon: <WindowSharp />,
  },
  {
    text: "Profile",
    path: "/basicDetails",
    submenu: [
      {
        text: "Basic Details",
        path: "/basicDetails",
        child: [],
      },
      {
        text: "Contact",
        path: "/contact",
        child: [],
      },
      {
        text: "Working Information",
        path: "/workingInformation",
        child: [],
      },
      {
        text: "HR Information",
        path: "/hrInformation",
        child: [],
      },
      {
        text: "Account Information",
        path: "/accountInformation",
        child: [],
      },
      {
        text: "Education",
        path: "/education",
        child: [],
      },
      {
        text: "Experience",
        path: "/experience",
        child: [],
      },
      {
        text: "Other Documents",
        path: "/otherDocuments",
        child: [],
      },
      {
        text: "Family",
        path: "/family",
        child: [],
      },
      {
        text: "Follow Up",
        path: "/followUp",
        child: [],
      },
    ],
    icon: <ThreePOutlined />,
  },

  {
    text: "People",
    path: "/myTeam",
    icon: <Diversity1Outlined />,
    submenu: [
      {
        text: "My Team",
        path: "/myTeam",
        child: [],
      },
      {
        text: "Org Chart",
        path: "/orgChart",
        child: [],
      },
      {
        text: "Employee",
        path: "/employee",
        child: [],
      },
      {
        text: "Graphics",
        path: "/graphics",
        child: [],
      },
    ],
  },
  {
    text: "Leave",
    path: "/leaveApply",
    submenu: [
      {
        text: "Leave Apply",
        path: "/leaveApply",
        child: [],
      },
      {
        text: "Leave Balance",
        path: "/LeaveBalance",
        child: [],
      },
      {
        text: "LeaveHistory",
        path: "/LeaveHistory",
        child: [],

      },

      {
        text: "Leave Approval",
        path: "/LeaveApproval",
        child: [],
      },
      {
        text: "Leave Calendar",
        path: "/LeaveCalendar",
        child: [],
      },
      {
        text: "Leave Encashment",
        path: "/LeaveEncashment",
        child: [],
      },
      {
        text: "Restricted Holiday Apply",
        path: "/restrictedHolidayApply",
        child: [],
      },
      {
        text: "Comp Off",
        path: "/compOff",
        child: [],
      },
      {
        text: "Withdraw Leave Apply",
        path: "/withdrawLeaveApply",
        child: [],
      },
      {
        text: "Paternity Leave",
        path: "/paternityLeave",
        child: [],
      },
      {
        text: "History",
        path: "/history",
        child: [],
      },
      {
        text: "Maternity Leave",
        path: "/maternityLeave",
        child: [],
      },
    ],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Attendance",
    path: "/attendance/calendar",
    submenu: [
      {
        text: "Calendar",
        path: "/attendance/calendar",
        child: [],
      },
      {
        text: "Regularization",
        path: "/attendance/regularization",
        child: [],
      },
      {
        text: "Approvals",
        path: "/attendance/approvals",
        child: [],
      },
      {
        text: "AttendanceMuster",
        path: "/attendance/attendanceMuster",
        child: [],
      },
    ],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Probation",
    path: "/currentProbationList",
    submenu: [
      {
        text: "Current Probation List",
        path: "/currentProbationList",
        child: [],
      },
      {
        text: "Extended Probation List",
        path: "/extendedProbationList",
        child: [],
      },
      {
        text: "Confirmed Probation List",
        path: "/confirmedProbationList",
        child: [],
      },
    ],
    icon: <ContactMailOutlined />,
  },
  {
    text: "Employee Movement",
    path: "/reportingManagerMovements",
    submenu: [
      {
        text: "Reporting Manager Movements",
        path: "/reportingManagerMovements",
        child: [],
      },
      {
        text: "My Teams",
        path: "/myTeams",
        child: [],
      },
    ],
    icon: <MultipleStopOutlined />,
  },
  {
    text: "Events",
    path: "/events",
    submenu: [],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Holiday",
    path: "/empHolidays",
    submenu: [
      {
        text: "View All",
        path: "/empHolidays",
        child: [],
      },
      {
        text: "Restricted Holiday",
        path: "/epmRestrictedHolidays",
        child: [],
      },
      {
        text: "Holiday",
        path: "/empViewHolidays",
        child: [],
      },
    ],
    icon: <HolidayVillage />,
  },
  {
    text: "Colleague Birthday",
    path: "/colleagueBirthday",
    submenu: [],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Work Anniversary",
    path: "/workAnniversary",
    submenu: [],
    icon: <Diversity1Outlined />,
  },
  {
    text: "Policy",
    path: "/policy",
    submenu: [],
    icon: <HolidayVillage />,
  },
  {
    text: "Separation",
    path: "/employeeInfoSeparation",
    submenu: [
      {
        text: "Employee Information",
        path: "/employeeInfoSeparation",
        child: [],
      },
      {
        text: "As Reporting Manager",
        path: "/reportingManagerSeparation",
        child: [],
      },
      {
        text: "As Reviewer",
        path: "/reviewerSeparation",
        child: [],
      },
      {
        text: "Exit Interview",
        path: "/exitInterview",
        child: [],
      },
      {
        text: "No Dues / Clearance Status",
        path: "/noduesClearanceStatus",
        child: [],
      },
      {
        text: "IT Infra No-Dues Certificate",
        path: "/itInfraNoduesCertificate",
        child: [],
      },
      {
        text: "Admin No-Dues Certificate",
        path: "/adminNoduesCertificate",
        child: [],
      },
      {
        text: "Finance No-Dues Certificate",
        path: "/financeNoduesCertificate",
        child: [],
      },
      {
        text: "HR Ops No-Dues Certificate",
        path: "/hrOpsNoduesCertificate",
        child: [],
      },
      {
        text: "Account Information Approval",
        path: "/accountInfoApprovalSeparation",
        child: [],
      },
      {
        text: "Separation Report",
        path: "/separationReport",
        child: [],
      },
    ],
    icon: <NextPlanOutlined />,
  },
  {
    text: "Help Desk",
    path: "/myRequests",
    icon: <SmsOutlined />,
    submenu: [
      {
        text: "My Requests",
        path: "/myRequests",
      },
      {
        text: "My Tickets",
        path: "/myTickets",
      },
      {
        text: "My Team",
        path: "/helpDeskMyTeam",
      },
    ],
  },
  // {
  //   text: "Travel Claims",
  //   path: "/travel",
  //   submenu: [],
  //   icon: <DescriptionOutlined />,
  // },
  {
    text: "Settings",
    path: "/organization",
    icon: <BuildOutlined />,
    submenu: [
      {
        text: "Organization",
        path: "/organization",
      },
      {
        text: "Sub-Organization",
        path: "/subOrganization",
      },
      {
        text: "Business",
        path: "/business",
      },
      {
        text: "Band",
        path: "/band",
      },
      {
        text: "Blood Group",
        path: "/bloodGroup",
      },
      {
        text: "Division",
        path: "/division",
      },
      {
        text: "Function",
        path: "/function",
      },
      {
        text: "Grade",
        path: "/grade",
      },
      {
        text: "Work Location",
        path: "/workLocation",
      },
      {
        text: "Role of Intake",
        path: "/roleOfIntake",
      },
      {
        text: "Department",
        path: "/department",
      },
      {
        text: "Designation",
        path: "/designation",
      },
      {
        text: "Document",
        path: "/document",
      },
      {
        text: "Company Policy",
        path: "/companyPolicy",
      },
      {
        text: "State",
        path: "/state",
      },
      {
        text: "Zone",
        path: "/zone",
      },
      {
        path: "/client",
        text: "Client",
      },
      {
        path: "/helpDeskSpoc",
        text: "Help Desk",
      },
      {
        text: "Menu",
        path: "/menu",
      },
      {
        text: "SubMenu",
        path: "/submenu",
      },
      {
        text: "Role And Permission",
        path: "/rolesAndPermission",
      },
    ],
  },
  {
    text: "Employee List",
    path: "/employeeList",
    submenu: [
      {
        text: "Employee List",
        path: "/addemployee",
        child: [],
      },
    ],
    icon: <Groups />,
  },
  {
    text: "OnBoarding",
    path: "/dayZero",
    submenu: [
      {
        text: "Day Zero",
        path: "/dayZero",
        child: [],
      },
      {
        text: "On Boarding",
        path: "/onBoarding",
        child: [],
      },
      {
        text: "Seating Readiness & Id Card Request",
        path: "/seatingReadiness",
        child: [],
      },
      {
        text: "Email Creation",
        path: "/emailIdCreation",
        child: [],
      },
    ],
    icon: <Groups />,
  },
  {
    text: "Candidate OnBoarding",
    path: "/canditateOnboarding",
    submenu: [
      {
        text: "Candidate OnBoarding",
        path: "/canditateOnboarding",
        child: [],
      },
      {
        text: "Buddy Info",
        path: "/buddyInfo",
        child: [],
      },
      {
        text: "Induction Schedule",
        path: "/inductionSchedule",
        child: [],
      },
      {
        text: "Buddy Feedback",
        path: "/buddyFeedback",
      },
      {
        text: "Welcome Aboard",
        path: "/welcomeAboard",
      },
    ],
    icon: <Groups />,
  },
  {
    text: "Email Id Creation",
    path: "/emailIdCreationEmployee",
    submenu: [],
    icon: <EmailOutlined />,
  },
  {
    text: "Candidate Seating",
    path: "/candidateSeating",
    submenu: [],
    icon: <AirlineSeatReclineNormal />,
  },
  {
    text: "Attendance MGT",
    path: "/adminAttendance/adminAttendanceInfo",
    submenu: [
      {
        text: "Admin Attendance Info",
        path: "/adminAttendance/adminAttendanceInfo",
        child: [],
      },
      {
        text: "Onsite Attendance Process",
        path: "/adminAttendance/onsiteAttendanceProcess",
        child: [],
      },
      {
        text: "Weekend Policy",
        path: "/adminAttendance/weekendPolicy",
        child: [],
      },
      {
        text: "Attendance Muster",
        path: "/adminAttendance/attendanceMuster",
        child: [],
      },
      {
        text: "Month End Process",
        path: "/adminAttendance/monthEndProcess",
        child: [],
      },
      {
        text: "Shift Master",
        path: "/adminAttendance/shiftMaster",
        child: [],
      },
      {
        text: "Shift Roster Import",
        path: "/adminAttendance/shiftRosterImport",
        child: [],
      },
      {
        text: "Shift Roster",
        path: "/adminAttendance/shiftRoster",
        child: [],
      },
      {
        text: "Day Type History",
        path: "/adminAttendance/dayTypeHistory",
        child: [],
      },
      {
        text: "Admin Attendance Report",
        path: "/adminAttendance/attendanceReport",
        child: [],
      },
    ],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "Leave MGT",
    path: "/leaveTypeCategory",
    submenu: [
      {
        text: "LeaveType Category",
        path: "/leaveTypeCategory",
        child: [],
      },
      {
        text: "Employee Leave Balance",
        path: "/employeeLeaveBalance",
        child: [],
      },
      {
        text: "Leave Granter",
        path: "/leaveGranter",
        child: [],
      },
      {
        text: "Leave Calender Admin",
        path: "/leaveCalenderAdmin",
        child: [],
      },
      {
        text: "Leave Encashment Approval",
        path: "/leaveEncashmentApproval",
        child: [],
      },
      {
        text: "Leave Balance Import",
        path: "/leaveBalanceImport",
        child: [],
      },
      {
        text: "Leave Report",
        path: "/leaveReport",
        child: [],
      },
      {
        text: "Lock Attendance Date",
        path: "/lockAttendanceDate",
        child: [],
      },
    ],
    icon: <CalendarMonthOutlined />,
  },
  {
    text: "HR Probation",
    path: "/currentHrProbationList",
    submenu: [
      {
        text: "Current Probation List",
        path: "/currentHrProbationList",
        child: [],
      },
      {
        text: "Deemed Probation List",
        path: "/deemedHrProbationList",
        child: [],
      },
      {
        text: "Extended Probation List",
        path: "/extendedHrProbationList",
        child: [],
      },
      {
        text: "Confirmed Probation List",
        path: "/confirmedHrProbationList",
        child: [],
      },
    ],
    icon: <ContactMailOutlined />,
  },
  {
    text: "Hr Movement",
    path: "/hrMovement",
    submenu: [],
    icon: <MultipleStopOutlined />,
  },
  {
    text: "Help Desk Report",
    path: "/helpDeskReport",
    submenu: [],
    icon: <SmsOutlined />,
  },
  {
    text: "Payroll",
    path: "/payrollSettings",
    submenu: [
      {
        text: "Settings",
        path: "/payrollSettings",
      },
      {
        text: "Esic",
        path: "/esic",
      },
      {
        text: "CTC Breakup",
        path: "/ctcBreakup",
      },
      {
        text: "PF Logic",
        path: "/pflogic",
      },
      {
        text: "LWF Slab",
        path: "/LwfSlab",
      },
      {
        text: "Reimbursement Master setup",
        path: "/reimbursementmMaster",
      },
      {
        text: "FBP Master setup",
        path: "/fbpMaster",
      },
      {
        text: "Paysheet",
        path: "/paysheet",
      },
      {
        text: "Vpf",
        path: "/vpf",
      },
      {
        text: "Loan",
        path: "/loan",
      },
      {
        text: "ITDMaster",
        path: "/itdmaster",
      },
      {
        text: "YTD Report",
        path: "/ytdreport",
      },
      {
        text: "Reimbursement Approval",
        path: "/reimbursementapproval",
      },
      {
        text: "Report",
        path: "/report",
      },
      {
        text: "Monthly Import",
        path: "/monthlyimport",
      },
      {
        text: "IT Declaration",
        path: "/itdeclaration",
      },

      {
        text: "IT Declaration Report",
        path: "/itdeclarationreport",
      },
      {
        text: "Tax Sheet",
        path: "/taxsheet",
      },
      {
        text: "TDS Slab",
        path: "/tdsslab",
      },
      {
        text: "Employee FBP ",
        path: "/fbpemp",
      },
      {
        text: "FBP Release",
        path: "/fbprelease",
      },
      {
        text: "Arrears",
        path: "/arrears",
      },
      {
        text: "PTSlab",
        path: "/ptSlab",
      },
    ],
    icon: <MoneyIcon />,
  },
  {
    text: "Salary",
    path: "/payslip",
    submenu: [
      {
        text: "Payslip",
        path: "/payslip",
        child: [],
      },
      {
        text: "ItDeclaration",
        path: "/itDeclaration",
        child: [],
      },
      {
        text: "EmpFbp",
        path: "/empFbp",
        child: [],
      },
      {
        text: "ReimbursementClaims",
        path: "/reimbursementClaims",
        child: [],
      },
      // {
      //   text: "ProofOfInvestment",
      //   path: "/proofofinvestment",
      //   child: [],
      // },
    ],
    icon: <MoneyIcon />,
  },
  {
    text: "IIY - Invest In Yourself",
    path: "/courseMaster",
    submenu: [
      {
        text: "Course Master",
        path: "/courseMaster",
        child: [],
      },
    ],
    icon: <ThreePOutlined />,
  },
  {
    text: "IIY",
    path: "/iiyMyself",
    submenu: [
      {
        text: "Myself",
        path: "/iiyMyself",
      },

    ],
    icon: <Psychology />,
  },
  {
    text: "Mail Template",
    path: "/mailTemplate",
    submenu: [],
    icon: <MailIcon />,
  },
  // {
  //   text: "Performance",
  //   path: "/performance",
  //   submenu: [],
  //   icon: <WorkspacePremiumOutlined />,
  // },
  // {
  //   text: "Project Wave",
  //   path: "/projectemployee",
  //   submenu: [
  //     {
  //       text: "Employee",
  //       path: "/projectemployee",
  //       child: [],
  //     },
  //     {
  //       text: "ReportingManager",
  //       path: "/projectreporting",
  //       child: [],
  //     },
  //     {
  //       text: "Reviewer",
  //       path: "/projectreviewer",
  //       child: [],
  //     },
  //     {
  //       text: "Division",
  //       path: "/projectdivision",
  //       child: [],
  //     },
  //   ],
  //   icon: <TipsAndUpdatesIcon />,
  // },
];

export default menuItems;
